<div class="gw-space-y-4">
  <div
    *ngIf="!actions"
    class="gw-rounded-lg gw-border gw-border-border-normal gw-bg-background-elevation-2 gw-p-4"
  >
    <p class="gw-text-sm gw-text-text-secondary gw-m-0">
      {{ 'common.errorLoadingData' | translate }}
    </p>
  </div>

  <ng-container *ngIf="actions">
    <div
      *ngIf="!routerEnabled"
      class="gw-rounded-lg gw-border gw-border-border-normal gw-bg-background-elevation-2 gw-p-4"
    >
      <p class="gw-text-sm gw-text-text-secondary gw-m-0">
        {{ 'features.wallets.integrationRouting.disabledHint' | translate }}
      </p>
    </div>

    <div
      class="gw-flex gw-flex-wrap gw-items-center gw-justify-between gw-gap-3"
    >
      <h3 class="gw-text-base gw-font-semibold gw-text-text-primary gw-m-0">
        {{ 'features.wallets.integrationRouting.rulesTitle' | translate }}
      </h3>
      <gatewee-button
        *ngIf="routerEnabled"
        variant="primary"
        size="m"
        iconName="@tui.plus"
        [title]="'features.wallets.integrationRouting.addRule' | translate"
        (clicked)="openCreateDialog()"
      ></gatewee-button>
    </div>

    <div *ngIf="loading" class="gw-text-center gw-py-8">
      <p class="gw-text-text-secondary">{{ 'common.loading' | translate }}…</p>
    </div>

    <div
      *ngIf="!loading && routerEnabled && rules.length === 0"
      class="gw-text-center gw-py-8 gw-rounded-lg gw-border gw-border-border-normal gw-bg-background-elevation-2"
    >
      <p class="gw-text-text-secondary gw-m-0">
        {{ 'features.wallets.integrationRouting.empty' | translate }}
      </p>
    </div>

    <div
      *ngIf="!loading && routerEnabled && rules.length > 0"
      class="gw-overflow-x-auto gw-rounded-xl gw-border gw-border-border-normal gw-bg-background-elevation-1 gw-overflow-hidden"
    >
      <table tuiTable size="s" class="gw-w-full gw-table-size-s">
        <thead>
          <tr>
            <th tuiTh>
              <div [tuiCell]="'s'">
                <span tuiTitle class="gw-text-text-secondary gw-text-xs">{{
                  'features.wallets.integrationRouting.col.method' | translate
                }}</span>
              </div>
            </th>
            <th tuiTh>
              <div [tuiCell]="'s'">
                <span tuiTitle class="gw-text-text-secondary gw-text-xs">{{
                  'features.wallets.integrationRouting.col.amountRange'
                    | translate
                }}</span>
              </div>
            </th>
            <th tuiTh>
              <div [tuiCell]="'s'">
                <span tuiTitle class="gw-text-text-secondary gw-text-xs">{{
                  'features.wallets.integrationRouting.col.targetIntegration'
                    | translate
                }}</span>
              </div>
            </th>
            <th tuiTh>
              <div [tuiCell]="'s'">
                <span tuiTitle class="gw-text-text-secondary gw-text-xs">{{
                  'features.wallets.integrationRouting.col.priority' | translate
                }}</span>
              </div>
            </th>
            <th tuiTh>
              <div [tuiCell]="'s'">
                <span tuiTitle class="gw-text-text-secondary gw-text-xs">{{
                  'features.wallets.integrationRouting.col.active' | translate
                }}</span>
              </div>
            </th>
            <th tuiTh>
              <div [tuiCell]="'s'">
                <span tuiTitle class="gw-text-text-secondary gw-text-xs">{{
                  'features.wallets.integrationRouting.col.description'
                    | translate
                }}</span>
              </div>
            </th>
            <th tuiTh class="gw-text-right">
              <div [tuiCell]="'s'" class="gw-justify-end">
                <span tuiTitle class="gw-text-text-secondary gw-text-xs">{{
                  'common.table.columns.actions' | translate
                }}</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody tuiTbody>
          <tr
            *ngFor="let rule of rules"
            class="gw-border-b gw-border-border-normal"
          >
            <td tuiTd>
              <div [tuiCell]="'s'">
                <span class="gw-text-sm gw-text-text-primary">{{
                  rule.paymentMethod
                    ? (rule.paymentMethod | paymentMethod)
                    : ('features.wallets.integrationRouting.anyMethod'
                      | translate)
                }}</span>
              </div>
            </td>
            <td tuiTd>
              <div [tuiCell]="'s'">
                <span class="gw-text-sm gw-text-text-primary">{{
                  formatAmountRange(rule)
                }}</span>
              </div>
            </td>
            <td tuiTd>
              <div [tuiCell]="'s'">
                <span class="gw-text-sm gw-text-text-primary">{{
                  formatTargetIntegration(rule)
                }}</span>
              </div>
            </td>
            <td tuiTd>
              <div [tuiCell]="'s'">
                <span class="gw-text-sm gw-text-text-primary">{{
                  rule.priority
                }}</span>
              </div>
            </td>
            <td tuiTd>
              <div [tuiCell]="'s'">
                <span class="gw-text-sm gw-text-text-primary">{{
                  (rule.isActive
                    ? 'common.status.enabled'
                    : 'common.status.disabled'
                  ) | translate
                }}</span>
              </div>
            </td>
            <td tuiTd>
              <div [tuiCell]="'s'">
                <span class="gw-text-sm gw-text-text-secondary">{{
                  rule.description || '—'
                }}</span>
              </div>
            </td>
            <td tuiTd class="gw-text-right">
              <div
                [tuiCell]="'s'"
                class="gw-justify-end gw-gap-2 gw-flex gw-flex-wrap"
              >
                <gatewee-button
                  variant="outline"
                  size="s"
                  [title]="'common.actions.edit' | translate"
                  iconName="@tui.pencil"
                  (clicked)="openEditDialog(rule)"
                ></gatewee-button>
                <gatewee-button
                  variant="outline"
                  size="s"
                  [title]="
                    (rule.isActive
                      ? 'features.wallets.integrationRouting.deactivate'
                      : 'features.wallets.integrationRouting.activate'
                    ) | translate
                  "
                  [iconName]="rule.isActive ? '@tui.circle-off' : '@tui.check'"
                  (clicked)="toggleActive(rule)"
                ></gatewee-button>
                <gatewee-button
                  variant="outline"
                  size="s"
                  [title]="'common.actions.delete' | translate"
                  iconName="@tui.trash"
                  (clicked)="confirmDelete(rule)"
                ></gatewee-button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>
